// Keep in sync with resources in src/lang/i18n.ts
export const LangKeys: string[] = ['id', 'bd', 'bn', 'br', 'kr']

export const standardCountryLanguageCodes: { [key: string]: string } = {
    'id': 'id-ID',
    'bd': 'bn-BD',
    'bn': 'bn-BD',
}